import {createFileRoute} from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import {ROLES} from "@/lib/auth/roles";
import {getGuideYear} from "@/lib/filters/date/date-utils";
import {activeAdvisersNumberQueryOptions} from "@/lib/hooks/active-advisers";
import {topRatedAdvisersCountQueryOptions} from "@/lib/hooks/top-rated-advisers-count";
import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import TopRatedAdvisers from "@/modules/top-rated-advisers";
import {verifiedAdvisersNumberQueryOptions} from "@/modules/top-rated-advisers/hooks";
import {mergedTopRatedAdvisersSchema, TopRatedAdviserSearch} from "@/types/route-search-schemas";
import {DataLoader} from "@/types/router-context";
import {TOP_RATED_ADVISERS_PATH, TOP_RATED_ADVISERS_URL} from "@/utils/urls";

export const Route = createFileRoute(TOP_RATED_ADVISERS_PATH)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): TopRatedAdviserSearch => validateSearchWithDefaults(mergedTopRatedAdvisersSchema, search),
  loader: ({ context: { queryClient } }: DataLoader) => {
    if (isCurrentPage(TOP_RATED_ADVISERS_URL)) {
      return
    }

    queryClient.prefetchQuery(activeAdvisersNumberQueryOptions())
    queryClient.prefetchQuery(verifiedAdvisersNumberQueryOptions())
    queryClient.prefetchQuery(topRatedAdvisersCountQueryOptions(getGuideYear()))
  },

  beforeLoad: () => {
    const guideYear = getGuideYear()

    return {
      breadcrumbs: [
        {label: 'Reputation', path: '#'},
        {label: 'Top Rated Adviser ' + guideYear, path: TOP_RATED_ADVISERS_URL},
      ],
      children: <div className={'h-10'}></div>
    }
  }
})

function RouteComponent() {
  return (
    <div className={'flex flex-col items-left justify-center max-sm:p-5'}>
      <Authorisation
        roles={[
          ROLES.ROLE_VIEW_FIRM,
          ROLES.ROLE_EDIT_FIRM,
        ]}
        permissions={[]}>

        <TopRatedAdvisers/>
      </Authorisation>
    </div>
  )
}
